module.exports = __webpack_public_path__ + "img/star-nebula-1.0193dd4d.png";